module.exports = "/images/icon-ticket.svg?e050f5cf5955d594ede9a5541b8a87dd";